import React, { Component } from 'react';
import UseForm from './UseForm';
import { connect } from "react-redux";

import {
  fetchStores
} from "appRedux/actions/Coupons";



class Cupons extends Component {

  componentDidMount() {
    this.props.fetchStores();
  }


  render() {
    return (
        <UseForm />
    );
  }
}


export default connect(null, { fetchStores })(Cupons);










// WEBPACK FOOTER //
// ./src/routes/main/Cupons/list/index.js